/*
 * Public API Surface of angular2-signaturepad
 */

export * from './lib/angular2-signaturepad.component';
export * from './lib/angular2-signaturepad.module';
